import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useRoleModel } from "../roleModel";
import "../roleStyles.less";
import { ResourceDrawer } from "./ResourceDrawer";
import { YhBox } from "@src/components/YhBox";
import { RoleType } from "./roleType";
import { DetailUsers } from "./DetailUsers";

export function Role() {
  const { loadData, resetState, loadMenuTreeAll, loadRoleList } =
    useRoleModel();
  useEffect(() => {
    loadData({ pageNum: 1 }, {}).then();
    loadMenuTreeAll();
    loadRoleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetState]);
  return (
    <>
      <PageHeader />
      <div className="flex">
        <YhBox title="分组配置" width="400px" style={{ marginBottom:0 }} maxHeight="650px">
            <RoleType />
        </YhBox>
        <div style={{ width: "calc(100% - 400px)" }}>
          <DataBox />
        </div>
      </div>

      <DetailDrawer />
      <ResourceDrawer />
      <DetailUsers />
    </>
  );
}
